import { render, staticRenderFns } from "./ResourceVideoPlayer.vue?vue&type=template&id=1d3ff195&"
import script from "./ResourceVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./ResourceVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./ResourceVideoPlayer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports